<template>
  <div>
    <div style="width:100%;">
        <vs-popup title="학과 추가" :active.sync="close" @close="closePop()">
            <h4 class="text-center">{{activeCollege.name}}({{activeCollege.campus_name}})</h4>
            <div style="padding:20px">
                <div style="width:100%; background:#FAFBFC">
                    <div style="font-size:12px; padding:20px 25px; background:#FAFBFC; font-size:15px">
                        <div>
                            <div class="addDepart" style="display:flex; justify-content:center; width:100%">
                                <p style="width:20%; margin-bottom:0; margin-top:5px; line-height:40px">학과명</p>
                                <textarea style="width:250px; height:31px; margin-top:10px; resize:none; border:solid 2px #ADD8E6; border-radius:5px;" v-model='major'></textarea>
                            </div>
                            <div class="addDepart" style="display:flex; justify-content:center; width:100%">
                                <p style="width:20%; margin-bottom:0; margin-top:5px; line-height:40px">진로 분야</p>
                                <textarea style="width:250px; height:31px; margin-top:10px; resize:none; border:solid 2px #ADD8E6; border-radius:5px;" v-model='departJob[0]'></textarea>
                            </div>
                            <div class="addDepart" style="display:flex; justify-content:center; width:100%">
                                <p style="width:20%; margin-bottom:0; margin-top:5px; line-height:40px">학과 설명</p>
                                <textarea style="width:250px; height:80px; margin-top:10px; border:solid 2px #ADD8E6; border-radius:5px;" v-model='departInfo'></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="text-align:center">
                <vs-button :active.sync="close" @click="addMajor()">학과 추가</vs-button>
            </div>
        </vs-popup>
    </div>
  </div>
</template>

<script>
export default {
    props: ['popupState', 'department'],
    components: {

    },
    data() {
        return {
            major: '',
            departInfo: '',
            departJob: [],
            close: false,
        }
    },
    computed: {
        activeCollege() {
            return this.$store.state.etest.activeCollege
        },
        activeMajor() {
          return this.$store.state.etest.majorList
        },
    },
    created() {
        this.close = this.popupState
    },
    methods: {
        closePop() {
            this.$emit('close')
        },
        addMajor(){
          if(this.major == '') {
            this.$vs.notify({
              title: '실패',
              text: '추가할 학과명을 입력해주세요.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
          else {
          this.$store.dispatch('etest/addMajorItem', {
              'univ_id':this.activeCollege.id,
              'name': this.major,
              'group_type': null,
              'job_list': this.departJob,
              'info': this.departInfo
            }).then(()=>{
              this.$vs.notify({
                color: 'success',
                title: '완료',
                text: this.department+ '가 추가되었습니다.'
              })
              if(this.activeMajor.length == 1){
                this.department = this.activeMajor[0]
              }
            }).catch(() => {
              this.$store.dispatch('etest/getMajorList' , this.activeCollege.id)
              this.$vs.notify({
                color: 'danger',
                title: '실패',
                text: '관리자에게 문의 해주세요 :('
              })
            })
            this.$emit('close')
        }
      }
    },
}
</script>
<style>
    .addDepart textarea {
        padding: 6px 5px;
    }
</style>
